import { ProgressBar, Tooltip } from '@infl-ts/ui-advocate-components';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, IconButton, Skeleton } from '@mui/material';
import { Translation } from 'react-i18next';
import { Header } from './challenge-header';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingHeader = function LoadingHeader(_ref) {
  var onClose = _ref.onClose,
      showActions = _ref.showActions;
  return /*#__PURE__*/_jsxs(AppBar, {
    sx: {
      boxShadow: 'none'
    },
    color: "transparent",
    position: "sticky",
    "data-element": "AppBar",
    "data-component": "LoadingHeader",
    "data-source-file": "player-skeleton.tsx",
    children: [/*#__PURE__*/_jsxs(Header, {
      sx: {
        p: 2,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      },
      "data-element": "Header",
      "data-component": "LoadingHeader",
      "data-source-file": "player-skeleton.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        sx: {
          borderRadius: function borderRadius(t) {
            return t.shape.borderRadius;
          }
        },
        variant: "rectangular",
        height: 32,
        width: "45%",
        "data-element": "Skeleton",
        "data-component": "LoadingHeader",
        "data-source-file": "player-skeleton.tsx"
      }), /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        },
        "data-element": "Box",
        "data-source-file": "player-skeleton.tsx",
        children: showActions && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Skeleton, {
            variant: "circular",
            height: 24,
            width: 24
          }), /*#__PURE__*/_jsx(Skeleton, {
            sx: {
              borderRadius: function borderRadius(t) {
                return t.shape.borderRadius;
              },
              mr: 6,
              ml: 1
            },
            variant: "rectangular",
            height: 24,
            width: 42
          }), /*#__PURE__*/_jsx(Translation, {
            children: function children(t) {
              return /*#__PURE__*/_jsx(Tooltip, {
                title: t('Close'),
                children: /*#__PURE__*/_jsx(IconButton, {
                  onClick: onClose,
                  children: /*#__PURE__*/_jsx(CloseIcon, {})
                })
              });
            }
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(ProgressBar, {
      progress: 0,
      "data-element": "ProgressBar",
      "data-source-file": "player-skeleton.tsx"
    })]
  });
};

var PlayerSkeleton = function PlayerSkeleton(_ref2) {
  var onClose = _ref2.onClose,
      showHeaderActions = _ref2.showHeaderActions,
      children = _ref2.children;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(LoadingHeader, {
      onClose: onClose,
      showActions: showHeaderActions,
      "data-element": "LoadingHeader",
      "data-component": "PlayerSkeleton",
      "data-source-file": "player-skeleton.tsx"
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        py: {
          xs: 3,
          md: 5
        },
        mx: 'auto',
        width: '100%',
        px: 2.5,
        maxWidth: 860,
        display: 'flex',
        flexDirection: 'column'
      },
      "data-element": "Box",
      "data-source-file": "player-skeleton.tsx",
      children: children !== null && children !== void 0 ? children : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Skeleton, {
          sx: {
            mt: 4,
            mb: 5
          },
          variant: "rectangular",
          width: "100%",
          height: 400
        }), /*#__PURE__*/_jsx(Skeleton, {
          sx: {
            mb: 1
          },
          variant: "text",
          width: 250
        }), /*#__PURE__*/_jsx(Skeleton, {
          sx: {
            mb: 5
          },
          variant: "text",
          width: 200
        }), /*#__PURE__*/_jsx(Skeleton, {
          sx: {
            borderRadius: function borderRadius(t) {
              return t.shape.borderRadius;
            }
          },
          variant: "rectangular",
          width: 128,
          height: 35
        })]
      })
    })]
  });
};

export default PlayerSkeleton;